"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Footer = exports.Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footer",
  componentId: "sc-1eox67n-0"
})(["align-items:center;display:flex;justify-content:space-between;margin-block-end:calc(-1 * ", ");margin-inline-start:calc(-1 * ", ");padding-block-start:", ";"], (0, _index.cssSpacing)('tighter-2', '8px'), (0, _index.cssSpacing)('tighter-4', '4px'), (0, _index.cssSpacing)('looser', '24px'));